import { createReducer, on } from '@ngrx/store';

import { initActions } from '../actions/init.actions';
import { limitsActions } from '../actions/limits.actions';
import { ActionUIState } from '../models/states.models';

export const featureKey = 'limits';

export interface LimitsState extends ActionUIState {
  maps?: {
    balance: number;
    limit: number | 'unlimited';
  };
  archivedMaps?: {
    balance: number;
    limit: number | 'unlimited';
  };
}

export const initialState: LimitsState = {
  status: 'INIT',
};

export const reducer = createReducer<LimitsState>(
  initialState,
  on(initActions.appCleanup, () => initialState),

  on(limitsActions.fetchMapsBalance, (state) => ({
    ...state,
    status: 'LOADING',
  })),
  on(limitsActions.fetchMapsBalanceSuccess, (state, { data }) => ({
    ...state,
    ...data,
    status: 'READY',
  })),
  on(limitsActions.fetchMapsBalanceFail, (state, { error }) => ({
    ...state,
    status: 'ERROR',
    error,
  }))
);
